import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Logo } from './Logo';
const PHONE = '586-203-3701';
const EMAIL = 'MoceriRS@gmail.com';
export function Footer() {
  return <footer className="bg-[#0f1620] text-slate-300 pt-14 pb-24 md:pb-10" data-id="element-51">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-52">
        <div className="grid md:grid-cols-3 gap-10 items-start" data-id="element-53">
          <div className="flex flex-col items-center md:items-start" data-id="element-54">
            <Logo size={80} className="mb-3" data-id="element-55" />
            <p className="font-display italic text-2xl text-white mb-1" data-id="element-56">
              Quality That's Through The Roof
            </p>
            <p className="text-sm text-slate-400 text-center md:text-left" data-id="element-57">
              Moceri Residential Services LLC — Michigan's trusted residential
              roofing company.
            </p>
          </div>

          <div className="text-center md:text-left" data-id="element-58">
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-59">
              Contact
            </h4>
            <ul className="space-y-3" data-id="element-60">
              <li data-id="element-61">
                <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center gap-2 hover:text-[#2DB8E0] transition-colors" data-id="element-62">
                  <Phone className="w-4 h-4 text-[#2DB8E0]" data-id="element-63" /> {PHONE}
                </a>
              </li>
              <li data-id="element-64">
                <a href={`mailto:${EMAIL}`} className="inline-flex items-center gap-2 hover:text-[#2DB8E0] transition-colors" data-id="element-65">
                  <Mail className="w-4 h-4 text-[#2DB8E0]" data-id="element-66" /> {EMAIL}
                </a>
              </li>
              <li className="inline-flex items-center gap-2" data-id="element-67">
                <MapPin className="w-4 h-4 text-[#2DB8E0]" data-id="element-68" /> Serving all of
                Michigan
              </li>
            </ul>
          </div>

          <div className="text-center md:text-left" data-id="element-69">
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-70">
              Services on This Page
            </h4>
            <ul className="space-y-2 text-sm" data-id="element-71">
              <li data-id="element-72">Shingle Roof Replacement</li>
              <li data-id="element-73">Asphalt Shingle Installation</li>
              <li data-id="element-74">Storm Damage Roof Replacement</li>
              <li data-id="element-75">Free Roof Inspections</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500" data-id="element-76">
          <p data-id="element-77">
            &copy; {new Date().getFullYear()} Moceri Residential Services LLC.
            All rights reserved.
          </p>
          <p data-id="element-78">Licensed & Insured in the State of Michigan</p>
        </div>
      </div>
    </footer>;
}